<template>
    <div class="scene">
        <canvas class="canvas"></canvas>
    </div>
</template>

<script>
import S from './Animation'

export default {
    mounted() {
        S.Drawing.init('.canvas')
        document.body.classList.add('body--ready')
        S.UI.simulate('#circle|#countdown 3|陈|林|子|你|好|胖', 2000)
        S.Drawing.loop(function() {
            S.Shape.render()
        })
    }
}
</script>

<style scoped>
.scene {
    width: 100vw;
    height: 100vh;
}

.canvas {
    width: 100vw;
    height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/scene3/Scene3.vue